import { useQuery } from 'react-query'
import { jobsService } from '../services/jobs'
import { useMutationWithToast } from '../../../hooks/useMutationWithToast'
import { useToast } from '../../../contexts/NotificationContext'
import {
  AtualizarJobScheduleDto,
  JobDefinicao,
  JobExecucaoHistorico,
  JobExecutarResposta,
} from '../tipos/job'

export function useJobs() {
  const toast = useToast()
  return useQuery<JobDefinicao[]>('jobs', () => jobsService.listar(), {
    staleTime: 30_000,
    onError: (error: any) => {
      toast.error('Erro', error?.message || 'Erro ao carregar jobs')
    },
  })
}

export function useHistoricoJob(id: number | null, take = 20) {
  const toast = useToast()
  return useQuery<JobExecucaoHistorico[]>(
    ['job-historico', id, take],
    () => jobsService.obterHistorico(id!, take),
    {
      enabled: !!id,
      onError: (error: any) => {
        toast.error('Erro', error?.message || 'Erro ao carregar historico do job')
      },
    },
  )
}

export function useAtualizarSchedule() {
  return useMutationWithToast<JobDefinicao, { id: number; data: AtualizarJobScheduleDto }>({
    mutationFn: ({ id, data }) => jobsService.atualizarSchedule(id, data),
    successMessage: 'Parametrização atualizada com sucesso!',
    errorMessage: 'Erro ao atualizar parametrização',
    invalidateQueries: 'jobs',
  })
}

export function useAlternarAtivo() {
  return useMutationWithToast<JobDefinicao, { id: number; ativo: boolean }>({
    mutationFn: ({ id, ativo }) => jobsService.alternarAtivo(id, ativo),
    errorMessage: 'Erro ao alterar status do job',
    invalidateQueries: 'jobs',
  })
}

export function useExecutarAgora() {
  return useMutationWithToast<JobExecutarResposta, number>({
    mutationFn: (id) => jobsService.executarAgora(id),
    successMessage: 'Execução enfileirada. Acompanhe pelo histórico.',
    errorMessage: 'Erro ao disparar execução manual',
    invalidateQueries: ['jobs', 'job-historico'],
  })
}
